import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import { HttpClient } from "@angular/common/http";

declare var separm: any;

@Injectable()
export class FraudnetService {

  public generatedFraudnetToken: BehaviorSubject<string> = new BehaviorSubject<string>("");

  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Gera um token Fraudnet pelo JSC.
   * Atualiza o BehaviorSubject com o valor gerado
   */
  async generateNewFraudnetToken() {
    await new Promise(r => {
      separm.seform('prefs_se');
      this.generatedFraudnetToken.next(this.getPayloadContent());
    });
  }

  /**
   * Retorna o token gerado para o Fraudnet.
   * O JSC coleta os dados e insere o token num campo no HTML, com id prefs_se.
   *
   * @return string contendo o token Fraudnet, caso exista
   */
  public getPayloadContent(): string {
    var elem = (<HTMLInputElement> document.getElementById('prefs_se'));
    if (elem) {
      return elem.value;
    }
  }

  /**
   * Faz uma chamada a uma API externa que retorna o IP local do cliente.
   * Deve ser chamada somente ao realizar o checkout para evitarmos problemas de atingir
   * limite de uso da API.
   *
   * @return string com o IP do cliente, caso a chamada seja feita com sucesso
   */
  public getIP(): Observable<any> {
    const API_URL = "https://api.ipify.org/?format=json";
    return this.httpClient.get(API_URL);
  }

}
